import { memo, useCallback, useEffect } from 'react';
import { Box, Text, Image, Button } from '@betty/moonlight';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import { useTranslation } from '@betty/i18n';
import {
  selectStatus,
  statusBackgroundTokenMap,
  statusBadgeMap,
} from '@betty/status';
import { BottomSheet } from '@betty/navigation';
import WheelSpinsSkeleton from './WheelSpinsSkeleton';
import {
  fetchSpinsCount,
  selectRemainingSpinsCount,
  selectRemainingSpinsCountState,
} from '@betty/instant-wheel';

function WheelSpinSection() {
  const dispatch = useDispatch();
  const { t } = useTranslation('rewards');
  const spinsCountDataState = useSelector(selectRemainingSpinsCountState);
  const spinsCount = useSelector(selectRemainingSpinsCount);

  const userStatus = useSelector(selectStatus);

  useEffect(() => {
    dispatch(fetchSpinsCount());
  }, [dispatch]);

  const onPress = useCallback(() => {
    if (userStatus?.playerStatus) {
      BottomSheet.open({
        namespace: 'instantWheel',
        type: 'InstantWheel',
        borderGradient: statusBackgroundTokenMap[userStatus.playerStatus],
        headerImageName: statusBadgeMap[userStatus.playerStatus],
        borderStyle: 'allsides',
      });
    }
  }, [userStatus]);

  if (spinsCountDataState === 'pending') {
    return <WheelSpinsSkeleton />;
  }

  return spinsCount ? (
    <Box
      flex={1}
      marginTop="space-400"
      paddingHorizontal="space-400"
      gap="space-200"
    >
      <Text
        variant="h6"
        locNS="rewards"
        locKey="yourWheelSpins"
        gradient="darkSurfaceAccent"
      />
      <Box
        variant="gradient"
        gradient="accentBackground"
        padding="space-800"
        borderRadius="radius-200"
        flex={1}
        justifyContent="space-between"
        alignItems="center"
        gap="space-800"
      >
        <Text variant="body-m-semi">
          {t('xWheelSpinsWithCount', {
            count: spinsCount,
          })}
        </Text>

        <Image name="rewards.wheel" width={200} height={200} />

        <Button
          width="100%"
          light={true}
          variant="primary"
          locNS="rewards"
          locKey="spinNow"
          onPress={onPress}
        />
      </Box>
    </Box>
  ) : null;
}

export default memo(WheelSpinSection);
